<template>
        <div class="inbanner bg-cover">
        <el-image src='images/xw/bg.jpg' width="100"  style="width: 100%; height: auto" fit="fill"></el-image>
  
      <div class="inwrap l-m-c">
        <h2 class="fnt_40 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">新闻咨询</h2>
        <h3 class="fnt_18 wow fadeInUp animated animated" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Happy Life</h3>
      </div>
    </div>
    <div   class="container"  >

 
          <div class="news-detail-container">
        <!-- 标题区域 -->
        <h1 class="news-title">{{ newsDetail.newTitle }}</h1>
        
        <!-- 作者与时间 -->
        <div class="meta-info">
          <span class="author">作者：{{ newsDetail.author }}</span>
          <span class="publish-time">发布时间：{{ newsDetail.releaseTime}}</span>
        </div>
        <br>
        <!-- 正文内容 -->
        <article class="content" v-html="newsDetail.newContent"></article>
    
      </div>
    </div>
</template>
<style scoped>
.news-detail-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.news-title {
  font-size: 24px;
  margin-bottom: 15px;
  line-height: 1.4;
}

.meta-info {
  color: #666;
  margin-bottom: 25px;
  font-size: 14px;
}

.author {
  margin-right: 15px;
}

.content {
  line-height: 1.8;
  font-size: 16px;
}

/* 处理富文本内容样式 */
.content :deep(img) {
  max-width: 100%;
  height: auto;
  margin: 10px 0;
}

.content :deep(p) {
  margin: 15px 0;
}
</style>
<script>
import { useStore } from 'vuex';
  export default {
     data() {
        return {
            content:'',
            newsDetail: {}
        }
     },
     methods: {
      
     },
     created(){
        const store = useStore();
        console.log(  store.state.newStore.currentNew);
        this.newsDetail =store.state.newStore.currentNew;
        this.content=store.state.newStore.currentNew.newContent
     },
   //   setup(){

   //    const route=useRoute();
   //    const params =route.params.newContent;
   //    onMounted(()=>{
   //       console.log(params)
   //    })
   //    return {
   //       params
   //    }
   //   }
  }
</script>
